export const isVzgptEnabled = (value) => value === true || value === 'true';

export const resolveIframeId = (value) => (value ? String(value) : '');

/**
 * Resolves the target origin for postMessage calls to the parent frame.
 *
 * Resolution order:
 * 1. `parentOrigin` URL query parameter (embedding contract when Referrer-Policy omits referrer)
 * 2. `document.referrer` origin
 * 3. `window.location.origin` — only reliable when parent and iframe share origin; cross-origin
 *    embeds without referrer or query param may fail postMessage delivery silently
 */
export const resolveParentOrigin = () => {
  try {
    const queryOrigin = new URLSearchParams(window.location.search).get('parentOrigin');

    if (queryOrigin) {
      const parsedOrigin = new URL(queryOrigin).origin;

      if (parsedOrigin && parsedOrigin !== 'null') {
        return parsedOrigin;
      }
    }
  } catch (error) {
    // Fall through to referrer-based resolution.
  }

  try {
    if (document.referrer) {
      const referrerOrigin = new URL(document.referrer).origin;

      if (referrerOrigin && referrerOrigin !== 'null') {
        return referrerOrigin;
      }
    }
  } catch (error) {
    // Fall through to same-origin fallback.
  }

  return window.location.origin;
};

